// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  userServiceUrl: 'https://ab-test.internal.sparbankensyd.se/service',
  defectServiceUrl: 'https://ab-test.internal.sparbankensyd.se/api',
  domain: 'ab-stage.internal.sparbankensyd.se'
}
